
export default {
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: '' },
    text: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
}
